import { IPreloadCacheContext } from 'framework/context/IPreloadCacheContext';
import { IEntPhysicianWithOfficesSummary } from 'gen/ApiClient';
import React from 'react';

export const EntPhysiciansCacheContext = React.createContext<IPreloadCacheContext<IEntPhysicianWithOfficesSummary[]>>(undefined as any);
